import { Action } from '@ngrx/store';
import {StatusLog, StatusParams} from '../status.model';

export enum StatusLogActionTypes {
  LoadStatusLogs = '[StatusLog] Load StatusLogs',
  GetStatusLogs = '[StatusLog] Get StatusLogs',
  GetStatusLogsFail = '[StatusLog] GetStatusLogsFail',
  ClearStatusLogs = '[StatusLog] Clear StatusLogs'
}

export class LoadStatusLogs implements Action {
  readonly type = StatusLogActionTypes.LoadStatusLogs;
  constructor(public payload: StatusLog[] ) {}
}

export class GetStatusLogs implements Action {
  readonly type = StatusLogActionTypes.GetStatusLogs;
  constructor(public payload: StatusParams ) {}
}

export class GetStatusLogsFail implements Action {
  readonly type = StatusLogActionTypes.GetStatusLogsFail;
}

export class ClearStatusLogs implements Action {
  readonly type = StatusLogActionTypes.ClearStatusLogs;
}


export type StatusLogActions = LoadStatusLogs
  | GetStatusLogs
  | GetStatusLogsFail
  | ClearStatusLogs;
